import { PencilSimple, Trash } from "@phosphor-icons/react";

const formatMoney = (amount) => {
  return new Intl.NumberFormat("en-MY", {
    style: "currency",
    currency: "MYR",
    minimumFractionDigits: 2,
  }).format(amount || 0);
};

const paymentStatus = (payment) => {
  if (payment.entry_type === "settlement") {
    return { className: "payment-on-time", label: "Settled" };
  }
  const lateDays = Number(payment.days_late || 0);
  return {
    className: lateDays > 0 ? "payment-late" : "payment-on-time",
    label: lateDays > 0 ? `${lateDays} days late` : "On time",
  };
};

export const LoanPaymentTimeline = ({
  canEdit,
  onDelete,
  onDeleteSettlement,
  onEdit,
  onEditSettlement,
  payments,
}) => {
  return (
    <section className="ledger-page-payments">
      <div className="section-heading">
        <div>
          <div className="eyebrow">Payment timeline</div>
          <h2>Due date and payment received tracking</h2>
        </div>
      </div>
      <div className="repayment-ledger-table-wrap">
        <table data-testid="repayment-ledger-table">
          <thead>
            <tr>
              <th>Payment</th>
              <th>Due Date</th>
              <th>Received Date</th>
              <th>Payment Status</th>
              <th className="amount">Amount</th>
              <th>Remark</th>
              <th className="amount">Balance</th>
              {canEdit && <th>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {payments.map((payment, index) => {
              const status = paymentStatus(payment);
              return (
                <tr
                  key={payment.id}
                  data-testid={(
                    payment.entry_type === "settlement"
                      ? "loan-settlement-timeline-event"
                      : `repayment-ledger-payment-${payment.id}`
                  )}
                >
                  <td>{index + 1}</td>
                  <td>{payment.due_date || "—"}</td>
                  <td>{payment.payment_received_date || "—"}</td>
                  <td>
                    <span className={status.className}>{status.label}</span>
                  </td>
                  <td className="amount">{formatMoney(payment.amount)}</td>
                  <td className="payment-timeline-remark">{payment.note || "Repayment"}</td>
                  <td className="amount">{formatMoney(payment.balance_after)}</td>
                  {canEdit && payment.entry_type !== "settlement" && (
                    <td>
                      <div className="customer-view-actions">
                        <button
                          className="customer-icon-button"
                          onClick={() => onEdit(payment)}
                          data-testid={`edit-payment-${payment.id}`}
                          aria-label={`Edit payment ${index + 1}`}
                          title="Edit payment"
                        >
                          <PencilSimple size={17} />
                        </button>
                        <button
                          className="customer-icon-button customer-delete-button"
                          onClick={() => onDelete(payment)}
                          data-testid={`delete-payment-${payment.id}`}
                          aria-label={`Delete payment ${index + 1}`}
                          title="Delete payment"
                        >
                          <Trash size={17} />
                        </button>
                      </div>
                    </td>
                  )}
                  {canEdit && payment.entry_type === "settlement" && (
                    <td>
                      <div className="customer-view-actions">
                        <button
                          className="customer-icon-button"
                          onClick={() => onEditSettlement(payment)}
                          data-testid={`edit-settlement-${payment.id}`}
                          aria-label="Edit settlement"
                          title="Edit settlement"
                        >
                          <PencilSimple size={17} />
                        </button>
                        <button
                          className="customer-icon-button customer-delete-button"
                          onClick={() => onDeleteSettlement(payment)}
                          data-testid={`delete-settlement-${payment.id}`}
                          aria-label="Remove settlement"
                          title="Remove settlement"
                        >
                          <Trash size={17} />
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
        {!payments.length && (
          <div className="empty-state" data-testid="repayment-ledger-empty-state">
            No repayments have been recorded for this loan yet.
          </div>
        )}
      </div>
    </section>
  );
};